module.exports = __webpack_public_path__ + "img/value-prop-fcec05b6291cb9964e64e36cb0b5b595.png";